import { LoadingContent } from "@/components/LoadingContent";
import { OAuthPolicyReview } from "@/features/oauth/policy-review";
import { needsPolicyReview } from "@/features/oauth/api";
import { useEffect, useRef, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import { Button, Stack } from "@mantine/core";
import { CenteredCard } from "@/components/CenteredCard";
import { useAppSession } from "@/features/auth/session";
import { continueOAuth, providerRedirect, needsReauthentication } from "@/features/oauth/api";
import { oauthRequestState } from "@/features/oauth/request";
import { OAuthErrorDetails } from "@/features/oauth/error-details";
function Resume() {
  const [request] = useState(() => oauthRequestState(""));
  const session = useAppSession();
  const started = useRef(false);
  const continuation = useMutation({
    mutationFn: async () => {
      if (!request.query) throw new Error(request.error ?? "Missing authorization request.");
      const result = await continueOAuth(request.query);
      window.location.assign(providerRedirect(result.url));
    },
  });
  useEffect(() => {
    if (!request.query || session.isPending || session.error || started.current) return;
    if (!session.data?.user) {
      window.location.replace("/auth/sign-in?next=%2Foauth%2Fresume");
      return;
    }
    started.current = true;
    continuation.mutate();
  }, [request, session.isPending, session.error, session.data, continuation]);
  if (session.data?.user && needsPolicyReview(continuation.error)) return <OAuthPolicyReview userId={session.data.user.id} onContinue={() => { continuation.reset(); continuation.mutate(); }} />;
  const needsLogin = needsReauthentication(continuation.error);
  return (
    <CenteredCard
      title="Continue authorization"
      description={
        request.error ??
        continuation.error?.message ??
        session.error?.message ??
        "Returning to your authorization request…"
      }
    >
      <Stack>
        {!request.error && !session.error && !continuation.error ? <LoadingContent label="Returning to your authorization request…" variant="rows" /> : null}
        <OAuthErrorDetails error={request.failure ?? continuation.error ?? session.error} />
        {needsLogin ? (
          <Button component="a" href="/auth/sign-in?next=%2Foauth%2Fresume">
            Sign in again
          </Button>
        ) : null}
        {session.error ? (
          <Button onClick={() => void session.refetch()}>Retry session check</Button>
        ) : null}
      </Stack>
    </CenteredCard>
  );
}
export const Route = createFileRoute("/oauth/resume")({ component: Resume });
